import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const Files3dIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.53 4.47L17.53 0.47C17.39 0.33 17.2 0.25 17 0.25H4C3.04 0.25 2.25 1.04 2.25 2V22C2.25 22.96 3.04 23.75 4 23.75H20C20.96 23.75 21.75 22.96 21.75 22V5C21.75 4.8 21.67 4.61 21.53 4.47ZM20.25 22C20.25 22.14 20.14 22.25 20 22.25H4C3.86 22.25 3.75 22.14 3.75 22V2C3.75 1.86 3.86 1.75 4 1.75H16.69L20.25 5.31V22Z"
        fill={color}
      />
      <path
        d="M12.31 8.46C12.12 8.35 11.88 8.35 11.68 8.46L7.38001 10.96C7.19001 11.07 7.07001 11.28 7.07001 11.5V16.5C7.07001 16.72 7.19001 16.93 7.38001 17.04L11.68 19.54C11.87 19.65 12.11 19.65 12.31 19.54L16.61 17.04C16.8 16.93 16.92 16.72 16.92 16.5V11.5C16.92 11.28 16.8 11.07 16.61 10.96L12.31 8.46ZM12 9.72L15.09 11.51L12 13.27L8.91001 11.51L12 9.72ZM8.33001 12.62L11.38 14.36V17.91L8.33001 16.14V12.62ZM12.62 17.91V14.36L15.67 12.62V16.14L12.62 17.91Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

Files3dIcon.displayName = 'Files3dIcon';
